import { userDisplayName } from "@cp/toolkit";
import { format } from "date-fns";

interface UploadedFile {
  createdAt: string;
  uploader?: Parameters<typeof userDisplayName>[0];
}

export const fileUploadDetails = (file: UploadedFile) => {
  const uploadedBy = userDisplayName(file.uploader);
  const uploadedOn = format(new Date(file.createdAt), "M/d/yy");

  return uploadedBy ? `${uploadedBy} on ${uploadedOn}` : uploadedOn;
};
